import { render, staticRenderFns } from "./clientTab.vue?vue&type=template&id=42bcb4ee&scoped=true"
import script from "./clientTab.vue?vue&type=script&lang=js"
export * from "./clientTab.vue?vue&type=script&lang=js"
import style0 from "./clientTab.vue?vue&type=style&index=0&id=42bcb4ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bcb4ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42bcb4ee')) {
      api.createRecord('42bcb4ee', component.options)
    } else {
      api.reload('42bcb4ee', component.options)
    }
    module.hot.accept("./clientTab.vue?vue&type=template&id=42bcb4ee&scoped=true", function () {
      api.rerender('42bcb4ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/traceback/videoManage/clientTab.vue"
export default component.exports